import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// Categories module configurations
export const LISTING_COLUMNS = [
  {
    id: 'name',
    label: 'Title',
    width: '20%',
    align: 'left',
    dataKey: 'name',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'chatRoomURL',
    label: 'Chat Room URL',
    width: '20%',
    align: 'left',
    dataKey: 'chatRoomURL',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'purchaseURL',
    label: 'Purchase URL',
    width: '20%',
    align: 'left',
    dataKey: 'purchaseURL',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    width: '10%',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.SWITCH,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    width: '15%',
    align: 'right',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.EDIT.value,
    label: ACTIONS.EDIT.label,
  },
  {
    action: ACTIONS.TRANSLATE.value,
    label: ACTIONS.TRANSLATE.label,
  },
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
];

export const VIEW_CATEGORIES_COLUMNS = [
  {
    id: 'name',
    label: 'Title',
    dataKey: 'name',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'chatRoomURL',
    label: 'Chat Room URL',
    dataKey: 'chatRoomURL',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'purchaseURL',
    label: 'Purchase URL',
    dataKey: 'purchaseURL',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'description',
    label: 'Description',
    dataKey: 'description',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    dataKey: 'status',
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
